import React, { useState } from "react";
import { Share2, Twitter, Facebook, Linkedin, Link2, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { toast } from "sonner";

const ShareButton = ({ title = "20 PROOF", label = "Share" }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const enc = encodeURIComponent;

  const socials = [
    { name: "X", Icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(url)}` },
    { name: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { name: "LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast("Link copied to clipboard");
      setTimeout(() => setCopied(false), 1600);
    } catch (err) {
      console.error("Clipboard copy failed", err);
      toast.error("Couldn\u2019t copy link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch (err) {
        console.debug("Native share dismissed", err);
      }
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="inline-flex items-center gap-2 font-sans-ui text-sm px-5 py-3 rounded-full border border-neutral-300 text-neutral-800 hover:border-neutral-900 transition-colors"
        >
          <Share2 size={16} />
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56 bg-[#eceae5] border-neutral-300 p-2">
        <button
          onClick={copy}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md font-sans-ui text-sm text-neutral-800 hover:bg-neutral-900 hover:text-white transition-colors"
        >
          {copied ? <Check size={16} /> : <Link2 size={16} />}
          {copied ? "Copied!" : "Copy link"}
        </button>
        {socials.map(({ name, Icon, href }) => (
          <a
            key={name}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md font-sans-ui text-sm text-neutral-800 hover:bg-neutral-900 hover:text-white transition-colors"
          >
            <Icon size={16} />
            Share on {name}
          </a>
        ))}
        {typeof navigator !== "undefined" && navigator.share && (
          <button
            onClick={nativeShare}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md font-sans-ui text-sm text-neutral-800 hover:bg-neutral-900 hover:text-white transition-colors"
          >
            <Share2 size={16} />
            More…
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default ShareButton;
